import { lazy } from "react";

export const ChooseAdvisorAsync = lazy(() => import("./ChooseAdvisor"));
